export default __webpack_public_path__ + "static/media/07.90375958.jpg";